// extracted by mini-css-extract-plugin
module.exports = {"brandedHeader":"brandedHeader_3rkX-","appTitle":"appTitle_2kfQP","mainMenu":"mainMenu_2wGY7","menuTitle":"menuTitle_WJVEZ"};